import { UserDTO } from '../common/Dtos';
import { Dialog, DialogActions, DialogContent, Table, TableBody, TableContainer } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { SCheckbox, SDialogButton, STitleContainer, STitleH3 } from '../common/BCommonComponents';
import { HeadCell, Order, STableCell, STableHeader, STableRow } from '../common/ScrivaniaTable';
import TablePagination from '@material-ui/core/TablePagination';
import { toast } from 'react-toastify';
import AuthContext from '../auth/AuthContext';

interface InserimentoOperatoriDialogProps {
	open: boolean;
	onClose: (selected?: UserDTO[]) => void;
	alreadyAssociated: UserDTO[];
	cooperativa: string;
}

export function InserimentoOperatoriDialog(props: InserimentoOperatoriDialogProps) {
	const auth = useContext(AuthContext);
	const {onClose, open, alreadyAssociated, cooperativa} = props;
	const [selected, setSelected] = useState<UserDTO[]>([]);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [totalRow, setTotalRow] = useState(0)
	const [order, setOrder] = useState<Order>('asc');
	const [orderBy, setOrderBy] = useState<string>('firstname');
	const [operatoreList, setOperatoreList] = useState<UserDTO[]>([])

	const headCells: HeadCell[] = [
		{id: 'firstname', numeric: false, disablePadding: true, label: 'NOME', sortable: true},
		{id: 'lastname', numeric: false, disablePadding: true, label: 'COGNOME', sortable: true},
		{id: 'email', numeric: false, disablePadding: true, label: 'eMAIL', sortable: true},
		{id: 'telefono', numeric: false, disablePadding: true, label: 'TELEFONO', sortable: true},
		{id: 'cooperativa', numeric: false, disablePadding: true, label: 'COOPERATIVA', sortable: true},
		{id: 'action', numeric: false, disablePadding: false, label: '', sortable: false}
	];

	useEffect(() => {
		getAll();
	}, [orderBy, order, page, rowsPerPage, cooperativa])

	useEffect(() => {
		setSelected([]);
	}, [open]);

	const getAll = () => {
		const qs = require('qs');
		auth.state.axiosInstance?.get('/api/accounts/operatori_by_cooperativa_first_or_last_name', {
			params: {
				nomeOrCognome: '',
				activatedOnly: true,
				cooperativa: cooperativa,
				page: page,
				size: rowsPerPage,
				sort: orderBy + ',' + order
			},
			paramsSerializer: params => {
				return qs.stringify(params)
			}
		})
			.then(res => {
				setOperatoreList(res.data.content);
				setTotalRow(res.data.totalElements);
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero degli Operatori!');
				console.log(error);
			})
	};

	const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.checked) {
			const newSelecteds = operatoreList ? operatoreList.map(op => op) : [];
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	};

	const handleChangePage = (event: unknown, newPage: number) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleRequestSort = (event: React.MouseEvent<unknown>, property: string) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	const handleCheckBoxClick = (event: React.MouseEvent<unknown>, user: UserDTO) => {
		const selectedIndex = selected.findIndex(u => u.id === user.id);
		let newSelected: UserDTO[] = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, user);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1),
			);
		}
		setSelected(newSelected);
	};

	const handleConfirmation = () => {
		if (selected && selected.length !== 0) {
			onClose(selected);
		} else {
			toast.error('🛑 Selezionare almeno un operatore!');
		}
	};

	const handleClose = () => {
		onClose();
	};

	const isSelected = (id: string) => selected.findIndex(u => u.id === id) !== -1;

	const isPresent = (user: UserDTO) => alreadyAssociated.findIndex(u => u.id === user.id) !== -1;

	return (
		<Dialog
			fullWidth={true}
			maxWidth="lg"
			open={open}>
			<DialogContent>
				<STitleContainer className="mt-0">
					<STitleH3>OPERATORI</STitleH3>
				</STitleContainer>
				<TableContainer className="mt-3">
					<Table
						aria-labelledby="tableTitle"
						size={'medium'}
						aria-label="enhanced table">
						<STableHeader
							numSelected={selected.length}
							onRequestSort={handleRequestSort}
							onSelectAllClick={handleSelectAllClick}
							order={order}
							orderBy={orderBy}
							rowCount={totalRow}
							headCells={headCells}
							addCheckbox={true}
							bgcolor="primary"
							sortable={true}
							disableAction={false}
						/>
						<TableBody>
							{operatoreList &&
							operatoreList
								.map((row, index) => {
									const isItemSelected = isSelected(row.id);
									const labelId = `enhanced-table-checkbox-${index}`;

									return (
										!isPresent(row) &&
										<STableRow
											hover
											role="checkbox"
											aria-checked={isItemSelected}
											tabIndex={-1}
											key={row.id}
											selected={isItemSelected}
										>
											<STableCell padding="checkbox">
												<SCheckbox
													checked={isItemSelected}
													inputProps={{'aria-labelledby': labelId}}
													onClick={(event) => handleCheckBoxClick(event, row)}
												/>
											</STableCell>
											<STableCell padding="none">{row.firstname}</STableCell>
											<STableCell padding="none">{row.lastname}</STableCell>
											<STableCell padding="none">{row.email}</STableCell>
											<STableCell padding="none">{row.telefono}</STableCell>
											<STableCell padding="none">{row.cooperativaName}</STableCell>
										</STableRow>
									);
								})}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[5, 10, 25]}
					component="div"
					count={totalRow}
					rowsPerPage={rowsPerPage}
					page={page}
					onChangePage={handleChangePage}
					onChangeRowsPerPage={handleChangeRowsPerPage}
					labelRowsPerPage={"Risultati per pagina"}
				/>
			</DialogContent>
			<DialogActions className="p-4">
				<SDialogButton className="float-right" disabled={!selected || selected.length === 0} onClick={handleConfirmation}>INSERISCI</SDialogButton>
				<SDialogButton className="float-right" onClick={handleClose}>ANNULLA</SDialogButton>
			</DialogActions>
		</Dialog>
	);
}